var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('div',[_c('driver-transactions-searcher')],1),_c('div',{staticStyle:{"flex":"1"}},[_c('driver-transactions-search-result')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }